var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpert1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M861.936 2249.221h-278.89v102.25h278.89v-102.25",
    style: {
      fill: "#100602",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.736 2333.367c-25.421 8.064-48.67-20.373-51.898-63.503l-24.895-317.343 94.51-5.63 22.428 293.738c3.243 43.183-14.763 84.672-40.145 92.738",
    style: {
      fill: "#250f08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.01209
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.867 2259.186c-.627 44.418-20.28 79.534-43.857 78.41-23.592-1.175-42.245-38.202-41.638-82.634l4.515-301.333 86.74-6.189-5.76 311.746",
    style: {
      fill: "#250f08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.978675
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.282 1954.59c-3.37 11.82-70.86 17.69-85.618 3.44-4.7-4.5-7.309-34.32-7.309-34.32h97.223s-1.637 21.54-4.296 30.88",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.846488
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.578 1907.97h-97.223v15.74h97.223v-15.74",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.846488
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.193 1951.457c3.032 11.993 75.722 21.629 92.367 8.22 5.29-4.232 9.742-33.862 9.742-33.862l-105.1-5.434s.617 21.601 2.991 31.076",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.880588
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.014 1904.662 105.1 5.434-.812 15.719-105.1-5.434.812-15.719",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.880588
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.53 2835.112c0-65.02-28.01-150.06-86.86-150.57-2.95-.01-37.54 77.62-66.19 77.62-4.16 0-8.49-1.499-12.91-4.06v248.23c91.66 0 165.96-76.68 165.96-171.22",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.42 2785.862s-44.4-111.21-9.06-131.84c5.41-3.13 23.12-17.54 27.69-13.22 41.15 39.1 11.25 83.78 24.01 104.98 12.81 21.19-32.54 115.84-42.64 40.08m-264.75 49.25c0-65.02 27.97-150.06 86.83-150.57 2.96-.01 37.57 77.62 66.2 77.62 4.18 0 8.5-1.499 12.87-4.06v248.23c-91.65 0-165.9-76.68-165.9-171.22",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.8 2785.862s44.34-111.21 8.99-131.84c-5.41-3.13-23.11-17.54-27.66-13.22-41.18 39.1-11.23 83.78-24.01 104.98-12.8 21.19 32.55 115.84 42.68 40.08m140.33 157.521s-54.9-84.98-139.55-87.33c0 0-27.46 77.07 27.64 113.28 55.12 36.25 114.24 0 114.24 0l-2.33-25.95",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.13 2943.383s41.16-85.59 54.16-90.87c0 0 18.66 8.55 16.55 32.55-2.13 24.07-26.96 104.23-65.76 96.21-38.81-7.96-11.72-24.21-4.95-37.89m-127.5-14.11s-15.33-82.73-52.27-109.87c-36.96-27.12-24.57 84.37 52.27 109.87m36.46-37.141c-13.68 0-25.43-4.91-31.36-12 0 0 14.72 8.36 31.36 8.36 17.47 0 31.38-8.36 31.38-8.36-5.97 7.09-17.68 12-31.38 12",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.74 2330.592c-8.55 0-15.51 7.17-15.51 16.03 0 8.86 6.96 16.01 15.51 16.01 8.62 0 15.57-7.15 15.57-16.01 0-8.86-6.95-16.03-15.57-16.03m-145.21 52.86c-8.59 0-15.52 7.17-15.52 16.04 0 8.88 6.93 16.05 15.52 16.05s15.56-7.17 15.56-16.05c0-8.87-6.97-16.04-15.56-16.04m60.27-97.029c-8.55 0-15.54 7.19-15.54 16.01 0 8.86 6.99 16.03 15.54 16.03 8.58 0 15.55-7.17 15.55-16.03 0-8.82-6.97-16.01-15.55-16.01m-196.38 93.309c-8.55 0-15.51 7.18-15.51 16.03 0 8.85 6.96 16.02 15.51 16.02 8.61 0 15.56-7.17 15.56-16.02s-6.95-16.03-15.56-16.03",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.617 2482.3-18.449-54.58 74.348-96.06 20.738 14.57-76.637 136.07",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m693.732 2674.51 60.287-1.283-.171 77.812-57.212 10.177",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.08599
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.455 2684.75s-117.846-26.88-139.685-59.23c-23.317-34.57-85.282-124.31-89.774-161.38-2.23-18.87 41.281-79.41 83.734-132.48l31.524 34.79-45.461 101.94s66.305 87.95 79.449 107.41l92.285 44.43 110.8 30.33",
    style: {
      fill: "#1c815f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.426 2859.883c1.096-8.466-4.685-16.05-12.89-17.368-8.167-1.242-15.985 4.59-17.4 12.97-1.38 8.406 4.41 16.27 12.846 17.584 8.589 1.357 16.37-4.752 17.444-13.186",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.845 2863.251c.784-8.513-5.286-15.875-13.52-16.847-8.179-1.01-15.752 5.027-16.899 13.479-1.12 8.439 4.917 16.156 13.468 17.195 8.542 1.02 16.228-5.38 16.951-13.827",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.364 2865.422c.374-8.59-5.976-15.7-14.182-16.233-8.189-.706-15.504 5.564-16.337 14.062-.814 8.476 5.504 16.023 14.1 16.745 8.67.564 16.085-6.08 16.419-14.574",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.944 2866.168c0-8.57-6.7-15.43-14.979-15.463-8.201-.383-15.149 6.16-15.601 14.717-.43 8.505 6.237 15.732 14.931 16.122 8.653.053 15.643-6.866 15.65-15.376",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.533 2865.676c-.334-8.564-7.296-15.045-15.537-14.92-8.229-.01-14.96 6.853-15.052 15.412-.075 8.517 6.886 15.4 15.541 15.433 8.667-.08 15.366-7.47 15.048-15.925",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.086 2864.03c-.705-8.543-7.897-14.798-16.108-14.325-8.197.25-14.703 7.46-14.445 15.97.302 8.558 7.494 15.175 16.132 14.837 8.637-.429 15.074-8.032 14.421-16.481",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.53 2861.11c-1.009-8.46-8.474-14.575-16.678-13.67-8.15.747-14.353 8.075-13.766 16.59.606 8.455 8.137 14.894 16.775 14.124 8.575-.925 14.733-8.539 13.67-17.044",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.856 2856.865c-1.493-8.348-9.155-14.07-17.29-12.961-8.11 1.226-13.988 8.77-13.035 17.206.987 8.493 8.75 14.687 17.354 13.367 8.595-1.178 14.402-9.187 12.971-17.612",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.967 2860.537c1.536-65.301-59.025-119.571-135.227-121.322-76.173-1.785-139.163 49.685-140.664 114.972-1.498 65.217 59.057 119.498 135.26 121.238 76.175 1.754 139.165-49.716 140.631-114.888",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.704 2906.18c-14.63 0-27.13-5.02-33.4-12.32 0 0 15.63 8.57 33.4 8.57 18.52 0 33.28-8.57 33.28-8.57-6.25 7.3-18.77 12.32-33.28 12.32m90.25 0c14.58 0 27.1-5.02 33.38-12.32 0 0-15.66 8.57-33.38 8.57-18.57 0-33.33-8.57-33.33-8.57 6.3 7.3 18.76 12.32 33.33 12.32",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.222 2763.687c27.493-.482 39.068 20.477 39.459 39.532l-77.239 1.355c-.39-19.055 11.5-40.426 37.78-40.887",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.607373
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.772 2871.202c.191-7.694-5.966-14.121-13.687-14.315-7.713-.184-14.087 5.965-14.278 13.67-.185 7.714 5.92 14.117 13.645 14.28 7.684.207 14.139-5.95 14.32-13.635",
    style: {
      fill: "#296075",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.295 2.538S56.35 9.747 62 5.487c.753-.567 2-2.337 1.75-3.398 0 0-1.75 2.808-6.214-.442-2.559-1.86-10.13-2.007-11.24.891",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.06717
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.004 2874.376c.102-3.2-2.426-5.874-5.586-5.925-3.245-.103-5.924 2.45-6 5.656-.063 3.195 2.465 5.84 5.715 5.911 3.201.067 5.813-2.417 5.87-5.642",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.983 2873.179a14.02 14.02 0 0 0-13.668-14.348c-7.683-.167-14.138 5.95-14.318 13.684-.165 7.692 6.009 14.117 13.668 14.287 7.718.154 14.102-5.966 14.318-13.623",
    style: {
      fill: "#296075",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.862 2876.012c.058-3.174 2.721-5.735 5.892-5.664a5.81 5.81 0 0 1 5.702 5.913 5.783 5.783 0 0 1-5.99 5.654c-3.15-.053-5.684-2.706-5.604-5.903",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.824 2351.25h-119.39l-1.379 296.85 120.769 28.71v-325.56",
    style: {
      fill: "#1c815f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m931.784 2481.883 18.45-54.58-74.349-96.06-20.738 14.57 76.637 136.07",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.946 2684.333s117.846-26.88 139.685-59.23c23.317-34.57 85.282-124.31 89.774-161.38 2.23-18.87-41.28-79.41-83.734-132.48l-31.524 34.79 45.461 101.94s-66.305 87.95-79.449 107.41l-92.285 44.43-110.8 30.33",
    style: {
      fill: "#1c815f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.07 2669.062c-12.99-1.57-28.03-18.12-24.01-41.89 3.4-20.17 18.77-31.57 24.8-41.93 5.97-10.32.498-29.6.498-29.6s51.02 41 38.57 83.69c-8.79 29.94-26.81 31.3-39.86 29.73",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.577 2350.833h119.39l1.38 296.85-120.77 28.71v-325.56",
    style: {
      fill: "#1c815f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.391 2351.25h-10.953v322.77h10.953v-322.77",
    style: {
      fill: "#13543f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.535 2644.47c0-2.03-1.597-3.67-3.594-3.67a3.665 3.665 0 0 0-3.66 3.67c0 2.01 1.641 3.63 3.66 3.63 1.997 0 3.594-1.62 3.594-3.63m0-61.76c0-2.03-1.597-3.65-3.594-3.65a3.647 3.647 0 0 0-3.66 3.65c0 1.97 1.641 3.59 3.66 3.59a3.592 3.592 0 0 0 3.594-3.59m0-61.78c0-1.99-1.597-3.61-3.594-3.61-2.019 0-3.66 1.62-3.66 3.61 0 2.03 1.641 3.65 3.66 3.65 1.997 0 3.594-1.62 3.594-3.65",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.535 2459.21c0-2.03-1.597-3.65-3.594-3.65a3.647 3.647 0 0 0-3.66 3.65c0 2 1.641 3.6 3.66 3.6 1.997 0 3.594-1.6 3.594-3.6m0-61.75c0-2.01-1.597-3.67-3.594-3.67-2.019 0-3.66 1.66-3.66 3.67 0 1.99 1.641 3.59 3.66 3.59a3.58 3.58 0 0 0 3.594-3.59",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.57 2602.352c-10.78-1.34-23.18-15.04-19.9-34.7 2.828-16.66 15.55-26.09 20.51-34.67 4.98-8.55.42-24.52.42-24.52s42.26 33.97 31.899 69.28c-7.23 24.77-22.13 25.9-32.93 24.61",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.33 2550.442c-8.07-1-17.38-11.26-14.88-25.99 2.088-12.53 11.62-19.56 15.35-26 3.73-6.43.3-18.39.3-18.39s31.69 25.47 23.94 51.94c-5.46 18.57-16.61 19.41-24.71 18.44",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.08 2487.972c-8.28-.989-17.87-11.55-15.33-26.73 2.21-12.91 11.99-20.22 15.84-26.82 3.83-6.6.328-18.88.328-18.88s32.6 26.16 24.63 53.43c-5.58 19.16-17.11 20.03-25.47 19",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.26 2481.102s-7.81 8.16-.902 18.93c4.59 7.07 27.16 7.92 31.37 1.1 5.97-9.55-1.52-18.36-1.52-18.36s-15.27 12.91-28.95-1.67",
    style: {
      fill: "#09181e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.09 2669.062c12.99-1.57 28.05-18.12 24.01-41.89-3.4-20.17-18.79-31.57-24.77-41.93-6.01-10.32-.5-29.6-.5-29.6s-51.06 41-38.56 83.69c8.75 29.94 26.78 31.3 39.82 29.73",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.63 2602.352c10.72-1.34 23.18-15.04 19.82-34.7-2.81-16.66-15.5-26.09-20.48-34.67-4.99-8.55-.38-24.52-.38-24.52s-42.26 33.97-31.95 69.28c7.25 24.77 22.17 25.9 32.99 24.61",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.89 2550.442c8.03-1 17.33-11.26 14.87-25.99-2.152-12.53-11.67-19.56-15.4-26-3.75-6.43-.29-18.39-.29-18.39s-31.7 25.47-23.96 51.94c5.47 18.57 16.62 19.41 24.78 18.44",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.1 2487.972c8.3-.989 17.87-11.55 15.29-26.73-2.17-12.91-11.99-20.22-15.8-26.82-3.87-6.6-.31-18.88-.31-18.88s-32.64 26.16-24.65 53.43c5.57 19.16 17.07 20.03 25.47 19",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#debb7e",
    d: "M58.295 54.242H46.838c-.837 0-1.602-.562-1.674-1.24l-1.544-14.48c-.108-1.013.636-1.83 1.744-1.83h14.403c1.052 0 1.846.871 1.738 1.883L59.968 53c-.072.68-.793 1.24-1.674 1.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0d5a8",
    d: "M59.768 36.693H45.365c-1.108 0-1.852.817-1.744 1.83l.22 2.057c-.103-.964.624-1.742 1.704-1.742h14.043c1.026 0 1.802.829 1.7 1.792l.218-2.054c.114-1.066-.63-1.883-1.738-1.883Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.34 44.5H13.66c-1.512 0-2.893-1.283-3.024-2.835L7.852 8.583C7.657 6.268 9 4.4 11 4.4h26c1.9 0 3.332 1.991 3.138 4.303l-2.774 32.962c-.131 1.552-1.432 2.835-3.023 2.835Z",
    className: "st3",
    style: {
      fill: "none",
      stroke: "#45413c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "matrix(.55395 0 0 .43763 39.272 34.767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.073 2301.303s11.406 10.47 8.7 13.55c-4.325 5.02-18.829-16.58-24.966-7.57-5.004 7.28 11.254 10.07 19.653 22.77 16.402 24.86 29.144 21.68 29.144 21.68l20.641-13.52s-27.48-50.64-30.96-54.04c-2.892-2.81-15.52-15.82-31.614-25.02-.665-.39-8.11 16.17-8.438 24.4-.469 11.85 17.84 17.75 17.84 17.75",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.92 2481.102s7.81 8.16.9 18.93c-4.65 7.07-27.17 7.92-31.39 1.1-5.94-9.55 1.54-18.36 1.54-18.36s15.24 12.91 28.95-1.67",
    style: {
      fill: "#0a1b25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.328 2301.72s-11.406 10.47-8.699 13.55c4.324 5.02 18.828-16.58 24.965-7.57 5.004 7.28-11.254 10.07-19.653 22.77-16.402 24.86-29.144 21.68-29.144 21.68l-20.641-13.52s27.481-50.64 30.961-54.04c2.891-2.81 15.52-15.82 31.613-25.02.665-.39 8.11 16.17 8.438 24.4.469 11.85-17.84 17.75-17.84 17.75",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06717 0 0 -.06717 4.249 201.938)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert1);
export default __webpack_public_path__ + "static/media/expert1.0bba0768f0cb5de80d5c50c7d353f6a8.svg";
export { ForwardRef as ReactComponent };